import { Component, HostListener, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'viva-warning-popup',
    templateUrl: './viva-warning-popup.component.html',
    styleUrls: ['./viva-warning-popup.component.scss'],
    standalone: false
})
export class VivaWarningPopupComponent  {

  readonly dialogTitleId = 'viva-warning-popup-title';

  @Input() message?: string;

  constructor(private modalController: ModalController) { }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    void this.dismiss();
  }

 async dismiss() {
    const topModal = await this.modalController.getTop();
    if (topModal) {
      await this.modalController.dismiss();
    }
  }

}
